module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.8a36205.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/Roboto-Regular.ttf
// module id = 3Pw6
// module chunks = 0